export default __webpack_public_path__ + "static/media/ternary_rel_teorey.319a6273.jpg";